/** PIN rules — mirrors pms-backend/src/utils/pinPolicy.js (server also blocks reuse). */
export const PIN_LENGTH = 4

export function isWeakPin(pin: string): boolean {
  if (/^(\d)\1{3}$/.test(pin)) return true // 0000, 1111 …
  const digits = [...pin].map(Number)
  if (digits.length !== PIN_LENGTH || digits.some((d) => Number.isNaN(d))) return false
  const steps = digits.slice(1).map((d, i) => d - digits[i]!)
  return steps.every((s) => s === 1) || steps.every((s) => s === -1) // 1234, 4321
}

/** Problem with a complete PIN, or null when acceptable. */
export function pinPolicyError(pin: string): string | null {
  if (!/^\d{4}$/.test(pin)) return `PIN must be ${PIN_LENGTH} digits`
  if (isWeakPin(pin)) return 'Too easy — avoid 1111 or 1234'
  return null
}
